/* eslint-disable @typescript-eslint/no-type-alias */
export type DocumentType = 'amendment' | 'base_lease' | 'other';

export interface LeaseDocument {
  id: number;
  document_type: DocumentType;
  effective_date: string | null;
  original_filename: string;
  pdf_url: string;
  download_url: string | null;
  ordinal: number;
  is_processed: boolean;
  progress: number;
  message: string;
  created: string;
}

export interface LeaseListItem {
  id: number;
  building_name: string;
  tenant_name: string;
  unit_suite: string;
  lease_start_date: string | null;
  lease_expiration_date: string | null;
  has_options: boolean;
  amendment_count: number;
  modified: string;
  is_processing: boolean;
  is_processed: boolean;
  progress: number;
  message: string;
}

export interface LeaseDetail extends LeaseListItem {
  documents: LeaseDocument[];
  lease_agreement_date: string;
  expiration_source: string;
}

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  base_lease: 'Base Lease',
  amendment: 'Amendment',
  other: 'Other',
};

export const DOCUMENT_TYPE_STYLES: Record<DocumentType, { bg: string; text: string }> = {
  base_lease: { bg: '#E8F5E9', text: '#2E7D32' },
  amendment: { bg: '#FFF3E0', text: '#E65100' },
  other: { bg: '#F3F4F6', text: '#6B7280' },
};
